var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2627 22.7375C5.80287 20.0433 9.25157 18.3875 13.0502 18.3875C16.8488 18.3875 20.2975 20.0433 22.8377 22.7375M17.9439 9.14375C17.9439 11.8465 15.7529 14.0375 13.0502 14.0375C10.3475 14.0375 8.15645 11.8465 8.15645 9.14375C8.15645 6.44101 10.3475 4.25 13.0502 4.25C15.7529 4.25 17.9439 6.44101 17.9439 9.14375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmins);
export default __webpack_public_path__ + "static/media/admins.04c8cb77c4efe1382a2111bf6f97eb19.svg";
export { ForwardRef as ReactComponent };